<template>
    <card class="form-horizontal">
        <div class="card-header">
        </div>
        <div v-if="loadingReviewComputed" class="card-body text-center">
            <div class="row">
                <p-button disabled type="block btn-warning">Descargando datos</p-button>
            </div>
        </div>
        <div v-if="!loadingReviewComputed && (this.$store.state.alert != null && this.$store.state.alert != '')" class="alert alert-info">
            <span>{{this.$store.state.alert}}</span>
        </div>
        <div v-if="!loadingReviewComputed" class="card-body text-center">
            <div class="row">
                <p-button @click="toPersonalData()" type="block btn-warning">Nueva evaluación</p-button>
            </div>
            <div class="row">
                <p-button @click="toPendingEvaluations()" type="block btn-warning">Evaluaciones pendientes</p-button>
            </div>
            <div class="row">
                <p-button @click="toFinishedEvaluations()" type="block btn-warning">Evaluaciones cerradas</p-button>
            </div>
            <div class="row">
                <p-button @click="toDeliveredEvaluations()" type="block btn-warning">Evaluaciones entregadas</p-button>
            </div>
            <!-- <div class="row">
                <p-button @click="toFM100()" type="block btn-info">Vista previa FM100</p-button>
            </div>
            <div class="row">
                <p-button @click="toFM102()" type="block btn-info">Vista previa FM102</p-button>
            </div> -->
        </div>
        <div class="card-footer">
        </div>
    </card>
</template>
    <script>
    import swal from 'sweetalert2'
    import SecureLS from 'secure-ls';
    import { Card } from 'src/components/UIComponents'
    import { activityTypes } from 'src/api/graphql/queries/setup/AllActivityTypes';
    import { productTypes } from 'src/api/graphql/queries/setup/AllProductTypes';
    import { creditTypes } from 'src/api/graphql/queries/setup/AllCreditTypes';
    import { creditPurposes } from 'src/api/graphql/queries/setup/AllCreditPurposes';
    import { identificationDocumentTypes } from 'src/api/graphql/queries/setup/AllIdentificationDocumentTypes';
    import { methodologicalPillars } from 'src/api/graphql/queries/setup/AllMethodologicalPillars';
    import { catalogSalePercent } from 'src/api/graphql/queries/setup/AllCatalogSalePercent';
    import { economicActivities } from 'src/api/graphql/queries/setup/AllEconomicActivities';
    import { professions } from 'src/api/graphql/queries/setup/AllProfessions';
    import { VERIFY_TOKEN } from 'src/api/graphql/mutations/auth/VerifyToken';
    import { REFRESH_TOKEN } from 'src/api/graphql/mutations/auth/RefreshToken';
    import axios from 'axios'
    export default {
        /***
        * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
        *
        **/
        apollo:{
            professions: {
                    query: professions,
                    // Disable the query
                    skip() {
                        return this.skipProfessionsQuery
                    },
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        if(data.professions.edges.length != 0)
                        {
                            this.setProfessions(data.professions);
                            this.skipProfessionsQuery = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
            },
            economicActivities: {
                    query: economicActivities,
                    // Disable the query
                    skip() {
                        return this.skipEconomicActivitiesQuery
                    },
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        if(data.economicActivities.edges.length != 0)
                        {
                            this.setEconomicActivities(data.economicActivities);
                            this.skipEconomicActivitiesQuery = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
            },
            methodologicalPillars: {
                    query: methodologicalPillars,
                    // Disable the query
                    skip() {
                        return this.skipMethodologicalPillarsQuery
                    },
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        if(data.methodologicalPillars.edges.length != 0)
                        {
                            this.setMethodologicalPillars(data.methodologicalPillars);
                            this.skipMethodologicalPillarsQuery = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
            },
            activityTypes: {
                    query: activityTypes,
                    // Disable the query
                    skip() {
                        return this.skipActivityTypesQuery
                    },
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.activityTypes.edges.length != 0)
                        {
                            this.setActivityTypes(data.activityTypes);
                            this.skipActivityTypesQuery = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
            },
            identificationDocumentTypes: {
                    query: identificationDocumentTypes,
                    // Disable the query
                    skip() {
                        return this.skipIdentificationDocumentType
                    },
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.identificationDocumentTypes.edges.length != 0)
                        {
                            this.setIdentificationDocumentType(data.identificationDocumentTypes);
                            this.skipIdentificationDocumentTypesQuery = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
            },
            productTypes: {
                    query: productTypes,
                    // Disable the query
                    skip() {
                        return this.skipProductTypesQuery
                    },
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.productTypes.edges.length != 0)
                        {
                            this.setProductTypes(data.productTypes);
                            this.skipProductTypesQuery = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
            },
            creditTypes: {
                    query: creditTypes,
                    // Disable the query
                    skip() {
                        return this.skipCreditTypesQuery
                    },
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.creditTypes.edges.length != 0)
                        {
                            this.setCreditTypes(data.creditTypes);
                            this.skipCreditTypesQuery = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
            },
            creditPurposes: {
                    query: creditPurposes,
                    // Disable the query
                    skip() {
                        return this.skipCreditPurposesQuery
                    },
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.creditPurposes.edges.length != 0)
                        {
                            this.setCreditPurposes(data.creditPurposes);
                            this.skipCreditPurposesQuery = true;
                        }
                        
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
            },
            catalogSalePercent: {
                    query: catalogSalePercent,
                    // Disable the query
                    skip() {
                        return this.skipCatalogSalePercent
                    },
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.catalogSalePercent.edges.length != 0)
                        {
                            this.setCatalogSalePercent(data.catalogSalePercent);
                            this.skipCatalogSalePercentQuery = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
            },
        },
        components: {
            Card
        },
        data() {
        return {
            skipEconomicActivitiesQuery: true,
            skipProfessionsQuery: true,
            skipMethodologicalPillarsQuery: true,
            skipActivityTypesQuery: true,
            skipProductTypesQuery: true,
            skipCreditTypesQuery: true,
            skipCreditPurposesQuery: true,
            skipIdentificationDocumentTypesQuery: true,
            skipCatalogSalePercentQuery: true,
        }
        },
        computed: {
            loadingReviewComputed () {
                if (this.$apollo.queries.productTypes.loading || this.$apollo.queries.activityTypes.loading || this.$apollo.queries.creditTypes.loading || this.$apollo.queries.creditPurposes.loading) {
                    return true
                }
                else {
                    return false
                }
            }
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifySession () {
                var vm = this;
                return new Promise(function(resolve, reject) {
                    var accessTokenDecoded = new SecureLS({encodingType: 'aes'});
                    var myToken = accessTokenDecoded.get('accessToken').data;
                    axios.defaults.headers.common["Authorization"] = 'Jwt '+myToken;
                    var refreshToken = accessTokenDecoded.get('refreshToken').data;
                    vm.$apollo.mutate({
                        mutation: VERIFY_TOKEN,
                        variables : {
                            input : {
                                token: myToken,
                            }
                        }
                    }).then((data) => {
                        resolve(true);
                    }).catch((error) => {
                        if(error.graphQLErrors.length > 0)
                        {
                            if (error.graphQLErrors[0].message == "Signature has expired") {
                                vm.$apollo.mutate({
                                    mutation: REFRESH_TOKEN,
                                    variables : {
                                        input : {
                                        refreshToken: refreshToken,
                                        }
                                    }
                                }).then((data) => {
                                    vm.$store.dispatch('updateToken',data.data.refreshToken).then(()=>{
                                        resolve(true);
                                    });
                                }).catch((error) => {
                                    resolve(false);
                                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');  
                                });
                            }
                        }
                        else {
                            resolve(false);
                            vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');    
                        }
                    }); 
                });
            },
            /***
            * Función para setear en la tabla los datos que llegan desde el servidor
            */
            async startRequest(){
                if(this.$store.state.connectivityState) {
                    let response = await this.verifySession();
                    if (response) {
                        if (this.$store.getters.getActivityTypes.length == 0) {
                            this.$apollo.queries.activityTypes.skip = false;
                            this.$apollo.queries.activityTypes.refetch();
                        }
                        if (this.$store.getters.getProductTypes.length == 0) {
                            this.$apollo.queries.productTypes.skip = false;
                            this.$apollo.queries.productTypes.refetch();
                        }
                        if (this.$store.getters.getCreditTypes.length == 0 || this.$store.getters.getCreditTypes.length != 0) {
                            this.$apollo.queries.creditTypes.skip = false;
                            this.$apollo.queries.creditTypes.refetch();
                        }
                        if (this.$store.getters.getCreditPurposes.length == 0) {
                            this.$apollo.queries.creditPurposes.skip = false;
                            this.$apollo.queries.creditPurposes.refetch();
                        }
                        if (this.$store.getters.getIdentificationDocumentTypes.length == 0) {
                            this.$apollo.queries.identificationDocumentTypes.skip = false;
                            this.$apollo.queries.identificationDocumentTypes.refetch();
                        }
                        if (this.$store.getters.getCatalogSalePercent.length == 0 ||this.$store.getters.getCatalogSalePercent.length != 0) {
                            this.$apollo.queries.catalogSalePercent.skip = false;
                            this.$apollo.queries.catalogSalePercent.refetch();
                        }
                        if (this.$store.getters.getMethodologicalPillars.length == 0 ||this.$store.getters.getMethodologicalPillars.length != 0) {
                            this.$apollo.queries.methodologicalPillars.skip = false;
                            this.$apollo.queries.methodologicalPillars.refetch();
                        }
                        if (this.$store.getters.getEconomicActivities.length == 0 ||this.$store.getters.getEconomicActivities.length != 0) {
                            this.$apollo.queries.economicActivities.skip = false;
                            this.$apollo.queries.economicActivities.refetch();
                        }
                        if (this.$store.getters.getProfessions.length == 0 ||this.$store.getters.getProfessions.length != 0) {
                            this.$apollo.queries.professions.skip = false;
                            this.$apollo.queries.professions.refetch();
                        }
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /***
            * Función para setear en la tabla los datos que llegan desde el servidor
            */
            setActivityTypes(activityTypes){
                var vm = this;
                for(let i=0;i<activityTypes.edges.length;i++)
                {
                    this.$store.commit('updateActivityTypes',activityTypes.edges[i].node);
                }
            },
            setMethodologicalPillars(methodologicalPillars){
                var vm = this;
                this.$store.commit('resetMethodologicalPillars');
                for(let i=0;i<methodologicalPillars.edges.length;i++)
                {
                    this.$store.commit('updateMethodologicalPillars',methodologicalPillars.edges[i].node);
                }
            },
            setEconomicActivities(economicActivities){
                var vm = this;
                this.$store.commit('resetEconomicActivities');
                for(let i=0;i<economicActivities.edges.length;i++)
                {
                    this.$store.commit('updateEconomicActivities',economicActivities.edges[i].node);
                }
                // for(let i=0;i<10;i++)
                // {
                //     this.$store.commit('updateEconomicActivities',economicActivities.edges[i].node);
                // }

            },
            setProfessions(professions){
                var vm = this;
                this.$store.commit('resetProfessions');
                for(let i=0;i<professions.edges.length;i++)
                {
                    this.$store.commit('updateProfessions',professions.edges[i].node);
                }
            },
            setIdentificationDocumentType(identificationDocumentTypes){
                var vm = this;
                for(let i=0;i<identificationDocumentTypes.edges.length;i++)
                {
                    this.$store.commit('updateIdentificationDocumentTypes',identificationDocumentTypes.edges[i].node);
                }
            },
            setCatalogSalePercent(catalogSalePercent){
                var vm = this;
                this.$store.commit('resetCatalogSalePercent');
                for(let i=0;i<catalogSalePercent.edges.length;i++)
                {
                    this.$store.commit('updateCatalogSalePercent',catalogSalePercent.edges[i].node);
                }
            },
            setProductTypes(productTypes){
                var vm = this;
                for(let i=0;i<productTypes.edges.length;i++)
                {
                    this.$store.commit('updateProductTypes',productTypes.edges[i].node);
                }
            },
            setCreditTypes(creditTypes){
                var vm = this;
                this.$store.commit('resetCreditTypes');
                for(let i=0;i<creditTypes.edges.length;i++)
                {
                    this.$store.commit('updateCreditTypes',creditTypes.edges[i].node);
                }
            },
            setCreditPurposes(creditPurposes){
                var vm = this;
                for(let i=0;i<creditPurposes.edges.length;i++)
                {
                    this.$store.commit('updateCreditPurposes',creditPurposes.edges[i].node);
                }
            },
            toPersonalData() {
                this.$store.dispatch('newAssesment').then(()=>{
                    this.$router.push('/asessments/new_asessment/customer/personal_data');
                });
            },
            toFM100() {
                this.$store.dispatch('newAssesment').then(()=>{
                    this.$router.push('/asessments/new_asessment/customer/fm100');
                });
            },
            toFM102() {
                this.$store.dispatch('newAssesment').then(()=>{
                    this.$router.push('/asessments/new_asessment/customer/fm102');
                });
            },
            toPendingEvaluations() {
                this.$router.push('/admin/pending_evaluations');
            },
            toFinishedEvaluations() {
                this.$router.push('/admin/finished_evaluations');
            },
            toDeliveredEvaluations() {
                this.$router.push('/admin/delivered_evaluations');
            }
        },
        mounted() {
            this.$store.dispatch('finishEvaluation', 'home').then(()=>{
                
            });
            // Con la siguiente función evitamos que el usuario pueda retroceder en el historial del navegador
            history.pushState(null, null, location.href);
            window.onpopstate = function () {
                history.go(1);
            };
            const url = process.env.VUE_APP_BACKEND_URL +'/api/gencookie';
            fetch(url)
            .then(data => data)
            .then(res => {
                // el resultado no importa, solo importa la cookie
                
            })
            .catch(error => { 
                console.info("Ocurrió un error al obtener la cookie!");
            });
            // this.startRequest();
        }
    }
</script>
<style>
</style>
